import { AbstractError } from '@/domain/errors/abstract-error.js';

export class ServerError extends AbstractError {
    public readonly code = 500;
    constructor(message = 'Internal server error', args?: string[]) {
        super(message, args);
    }
}
